import Reflux from "reflux";
import Freezer from "freezer-js";
import AskTheAuthorBannerActions from "../react_actions/ask_the_author_banner_actions";
import envUtils from "../modules/env_utils";

const initialStateData = { isBannerShown: true };
let state;
export default Reflux.createStore({
  listenables: AskTheAuthorBannerActions,

  getState() {
    return state.get();
  },

  getInitialState() {
    state = new Freezer(initialStateData);
    return this.getState();
  },

  reset() {
    this.getState().reset(initialStateData);
  },

  updateState(newStateData) {
    this.getState().set(newStateData);
    this.trigger(this.getState());
  },

  showBanner() {
    const newStateData = { isBannerShown: true };
    this.updateState(newStateData);
  },

  hideBanner() {
    const newStateData = { isBannerShown: false };
    this.updateState(newStateData);
  },

  onHideBanner() {
    this.hideBanner();
  },

  onOptAuthorIntoQA(authorID) {
    const url = `/ask_the_author/${authorID}/opt_in`;
    $j.post(url)
      .done((resp) => {
        this.hideBanner();
        envUtils.setLocationUrl(resp.return_url);
      })
      .fail(() => {
        //if there was an error opting author into qa, make sure the banner does not go away so user can retry
        this.showBanner();
        window.alert("Please try again.");
      });
  },
});
